import { render, staticRenderFns } from "./ModalDivider.vue?vue&type=template&id=47c971d7&scoped=true&"
import script from "./ModalDivider.vue?vue&type=script&lang=js&"
export * from "./ModalDivider.vue?vue&type=script&lang=js&"
import style0 from "./ModalDivider.vue?vue&type=style&index=0&id=47c971d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c971d7",
  null
  
)

export default component.exports